import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'

export function Spinner(): React.ReactElement {
  return (
    <FontAwesomeIcon
      icon={faSpinner}
      spin
      size="3x"
      className="text-primary"
      data-test="spinner"
      role="status"
      aria-label="Loading"
    />
  )
}

export function CenteredSpinner(): React.ReactElement {
  return (
    <div className="flex justify-center w-full">
      <Spinner />
    </div>
  )
}

export function SpinnerOverlay(): React.ReactElement {
  return (
    <div
      className="fixed inset-0 z-[10000] bg-black/20 flex items-center justify-center"
      data-test="spinner-overlay"
    >
      <div
        className="flex items-center justify-center bg-white rounded-[10px] h-[200px] w-[200px] mt-[15%] mx-auto border border-chrome shadow-[0_0_5px_#333]"
        data-test="spinner-box"
      >
        <Spinner />
      </div>
    </div>
  )
}
